import type { FormField } from '@cli-types/core-engine/schema.js'
import { generateFieldJSX } from './generate-field-jsx.js'
import { wrapShowWhen } from './wrap-show-when.js'

export function renderFieldsJSX(fields: FormField[]): string {
  return fields
    .filter((f) => !f.hidden)
    .map((f) => {
      if (f.type === 'dynamicFields') return ''
      if (f.type === 'group' && f.fields) {
        const cols = f.columns || 2
        const innerJSX = renderFieldsJSX(f.fields)
        const groupJSX = `        <div className="grid grid-cols-${cols} gap-5">\n${innerJSX}\n        </div>`
        return f.showWhen ? wrapShowWhen(f, groupJSX) : groupJSX
      }
      if (!f.name) return ''
      return wrapShowWhen(f, generateFieldJSX(f))
    })
    .filter(Boolean)
    .join('\n\n')
}
